/**
 * Persisted gallery tenant id for guest API paths (canonical id after auth / public-config).
 * Optional REACT_APP_GALLERY_ID is for local dev only.
 */
export const GALLERY_ID_STORAGE_KEY = 'weddingGalleryId';

export function getGalleryIdForApi() {
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_GALLERY_ID || '';
  }
  return (
    window.localStorage.getItem(GALLERY_ID_STORAGE_KEY) ||
    process.env.REACT_APP_GALLERY_ID ||
    ''
  );
}

export function setStoredGalleryId(galleryId) {
  if (galleryId && typeof window !== 'undefined') {
    window.localStorage.setItem(GALLERY_ID_STORAGE_KEY, galleryId);
  }
}

export function clearStoredGalleryId() {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(GALLERY_ID_STORAGE_KEY);
  }
}
